import React from 'react';
import { Icon } from './Icon.js';
export const IconChart2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "7", y: "2", width: "4", height: "14", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "1.5", y: "2", width: "4", height: "9", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "12.5", y: "2", width: "4", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconChart2Fill18.js.map